<template>
  <v-bottom-navigation dark app class="bottom-nav" background-color="primary" mandatory grow>
    <v-btn v-if="isVisitor" color="white" text :to="{name:PAGE_IDS.SEARCH}">
      <span>Search</span>
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn v-if="isVisitor" color="white" text :to="{name:PAGE_IDS.RESERVATIONS}">
      <span>My Spots</span>
      <img style="width:24px;margin-top:-1px;" src="/static/logo_small.png"/>
    </v-btn>
    <v-btn v-if="isVisitor" color="white" text :to="{name:PAGE_IDS.FAVORITES}">
      <span>Favorites</span>
      <v-icon>favorite</v-icon>
    </v-btn>
    <v-btn v-if="isSecurity || isStoreManager" color="white" text :to="{name:PAGE_IDS.SCAN}">
      <span>Scan</span>
      <v-icon>videocam</v-icon>
    </v-btn>
    <v-btn v-if="isStoreManager" color="white" text
           :to="{name:PAGE_IDS.STORE_DETAILS, params: {store_id: getCurrentStore}}">
      <span>Setup Stores</span>
      <v-icon>build</v-icon>
    </v-btn>
      <v-btn v-if="isStoreManager" color="white" text
           :to="{name:PAGE_IDS.STORE_DASHBOARD, params: {store_id: getCurrentStore}}">
      <span>Dashboard</span>
      <v-icon>dashboard</v-icon>
    </v-btn>
      <v-btn v-if="isBrandManager" color="white" text
           :to="{name:PAGE_IDS.BRAND_DASHBOARD}">
      <span>Dashboard</span>
      <v-icon>dashboard</v-icon>
    </v-btn>
    <v-btn v-if="isBrandManager" color="white" text :to="{name:PAGE_IDS.STORES_LIST}">
      <span>Stores</span>
      <v-icon>shopping_bag</v-icon>
    </v-btn>
    <v-btn v-if="isSuperAdmin" color="white" text :to="{name:PAGE_IDS.BRANDS_LIST}">
      <span>Brands</span>
      <v-icon style="transform: scale(-1, 1)">local_offer</v-icon>
    </v-btn>
    <v-btn color="white" text :to="{name:PAGE_IDS.PROFILE}" >
      <span>Profile</span>
      <v-icon>person</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    name: "BottomNavigation",
    computed: {
      ...mapGetters([
        'isVisitor',
        'isSecurity',
        'isStoreManager',
        'isBrandManager',
        'isSuperAdmin',
        'switchAvailable',
        'getCurrentStore',
      ])
    },
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Navigation/BottomNavigation.vue